import {
	IconButton as IconButtonMui,
	IconButtonProps as IconButtonPropsMui,
} from '@mui/material';

import styled from 'styled-components';

type IconButtonProps = IconButtonPropsMui;

const StyledIconButton = styled(IconButtonMui)<IconButtonProps>`
	background: white;
	border-radius: 0;
	border-top-right-radius: 4px;
	border-bottom-right-radius: 4px;
`;

const IconButtonTable: React.FC<IconButtonProps> = props => {
	return (
		<StyledIconButton
			{...props}
			sx={{
				left: { sm: 940, lg: 978 },
				height: { sm: 48, lg: 52 },
				width: { sm: 48, lg: 52 },
				...props.sx,
			}}
		>
			{props.children}
		</StyledIconButton>
	);
};

export default IconButtonTable;
